import {
  ASSUMPTION_EXCEPTION_STATUS,
  ASSUMPTION_STATUS,
  AssumptionExceptionPayload,
  AssumptionFormValues,
  AssumptionType,
  AssumptionUpdatePayload,
} from '../types';

const buildExceptionPayload = (
  assumption: AssumptionType | null,
  values: AssumptionFormValues,
  isFull: boolean,
): AssumptionExceptionPayload => {
  if (values.status !== ASSUMPTION_STATUS.VIOLATED) return {};

  if (Boolean(values.requestException)) {
    const { exceptionReason, exceptionUntilDate } = values;
    return {
      exceptionStatus: ASSUMPTION_EXCEPTION_STATUS.PENDING,
      exceptionReason,
      exceptionUntilDate,
    };
  }
  if (!isFull && assumption?.exceptionStatus) {
    return {
      exceptionStatus: assumption.exceptionStatus,
      exceptionReason: assumption.exceptionReason ?? undefined,
      exceptionUntilDate: assumption.exceptionUntilDate ?? undefined,
    };
  }
  return {};
};

export const buildUpdatePayload = (
  assumption: AssumptionType,
  values: AssumptionFormValues,
  isFull: boolean,
  updatedBy?: string,
): AssumptionUpdatePayload => ({
  id: assumption.id,
  description: values.description,
  assignedRole: values.assignedRole,
  status: values.status,
  ...(updatedBy ? { updatedBy } : {}),
  ...buildExceptionPayload(assumption, values, isFull),
});
